import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Configuración" },
  { label: "Categorías",    icon: "far fa-list-alt",  color: "#3b82f6", bg: "#eff6ff", href: "/Categorias",    desc: "Categorías de gastos",   perm: "menu_gastos" },
  { label: "SubCategorías", icon: "fas fa-list-ol",   color: "#6366f1", bg: "#eef2ff", href: "/SubCategorias", desc: "Sub-categorías",         perm: "menu_gastos" },
  { label: "Solicitantes",  icon: "fas fa-user",      color: "#64748b", bg: "#f8fafc", href: "/Solicitantes",  desc: "Personas que solicitan", perm: "menu_gastos" },

  { type: "section", label: "Registro" },
  { label: "Gastos",        icon: "fas fa-receipt",   color: "#f59e0b", bg: "#fffbeb", href: "/Gastos",        desc: "Registro de gastos",     perm: "menu_gastos" },
];

function BotonesGastos() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-wallet" color="#f59e0b" bg="#fffbeb" title="Gastos" subtitle="Administración de gastos y conceptos" />
        {user.menu_admin ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesGastos;
